/**
 * Fired when the signed-in session ends on this device (sign-out, idle
 * lock on the web, an expired session). Anything that holds one person's
 * state in memory above the navigator listens and resets (2026-10-02:
 * Orion's conversation used to carry over to the next account).
 */
export const SESSION_ENDED_EVENT = 'fk.sessionEnded';
